const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:3001/api';

class WatchlistService {
  async getWatchlist() {
    try {
      const response = await fetch(`${API_BASE_URL}/watchlist`, {
        credentials: 'include'
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
          return [];
        }
        throw new Error('Failed to get watchlist');
      }

      return await response.json();
    } catch (error) {
      console.error('Error getting watchlist:', error);
      throw error;
    }
  }

  async addToWatchlist(stock) {
    try {
      const response = await fetch(`${API_BASE_URL}/watchlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(stock),
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
          return null;
        }
        throw new Error('Failed to add to watchlist');
      }

      return await response.json();
    } catch (error) {
      console.error('Error adding to watchlist:', error);
      throw error;
    }
  }

  async removeFromWatchlist(symbol) {
    try {
      const response = await fetch(`${API_BASE_URL}/watchlist/${encodeURIComponent(symbol)}`, {
        method: 'DELETE',
        credentials: 'include',
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
          return null;
        }
        throw new Error('Failed to remove from watchlist');
      }

      return await response.json();
    } catch (error) {
      console.error('Error removing from watchlist:', error);
      throw error;
    }
  }

  async isInWatchlist(symbol) {
    try {
      const response = await fetch(`${API_BASE_URL}/watchlist/check/${encodeURIComponent(symbol)}`, {
        credentials: 'include'
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
          return false;
        }
        throw new Error('Failed to check watchlist');
      }

      const result = await response.json();
      return result.inWatchlist;
    } catch (error) {
      console.error('Error checking watchlist:', error);
      return false;
    }
  }

  async exportWatchlist() {
    try {
      const response = await fetch(`${API_BASE_URL}/watchlist/export`, {
        credentials: 'include'
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
          return null;
        }
        throw new Error('Failed to export watchlist');
      }

      return await response.json();
    } catch (error) {
      console.error('Error exporting watchlist:', error);
      throw error;
    }
  }

  async importWatchlist(importData) {
    try {
      const response = await fetch(`${API_BASE_URL}/watchlist/import`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(importData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
          return null;
        }
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to import watchlist');
      }

      return await response.json();
    } catch (error) {
      console.error('Error importing watchlist:', error);
      throw error;
    }
  }

  async reorderWatchlist(orderedSymbols) {
    try {
      const response = await fetch(`${API_BASE_URL}/watchlist/reorder`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ orderedSymbols }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
          return null;
        }
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to reorder watchlist');
      }

      return await response.json();
    } catch (error) {
      console.error('Error reordering watchlist:', error);
      throw error;
    }
  }
}

export const watchlistService = new WatchlistService();